// extracted by mini-css-extract-plugin
export var category = "_jp-9";
export var categoryHeader = "_jp-e";
export var container = "_jp-0";
export var group = "_jp-a";
export var groupItems = "_jp-f";
export var groupSeparator = "_jp-j";
export var loading = "_jp-1";
export var noResults = "_jp-3";
export var placeholder = "_jp-2";
export var resultContent = "_jp-5";
export var resultIcon = "_jp-c";
export var resultItem = "_jp-g";
export var resultMeta = "_jp-8";
export var resultSubtitle = "_jp-7";
export var resultSuffix = "_jp-i";
export var resultTitle = "_jp-6";
export var resultsList = "_jp-4";
export var searchGroup = "_jp-d";
export var selected = "_jp-h";
export var subgroup = "_jp-b";